















import { Vue, Component } from 'vue-property-decorator';
import { State } from 'vuex-class';
import { User } from '@/types';
import items from '@/game/definitions/items';
import moment from 'moment';

@Component
export default class UserControl extends Vue {
  @State public user!: User;

  public userJoinDate() {
    return moment(this.user.createdAt).fromNow();
  }
}
